import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../../laudo/etapas/material/material.action';
import * as commonActions from '../../../../../app/common/common.action';
import { ModalFaturamentoPage } from './modal.faturamento.page';
import WebapiCommon from '../../../../../app/common/util/webapi.common';
import { getUsuarioLocalStorage } from '../../../../../localStorage.util';
import ConfiguracaoApi from '../../../../configuracao/configuracao.api';

class ModalFaturamentoContainer extends Component {
  constructor() {
    super();
    this.state = {
      activeTab: '1',
      bloquearConfig: false,
      etapaSelecionada: undefined,
      quantidadeASerFaturada: 1,
      alertaPendentes: false,
      alertaTodoFaturado: false,
      faturamentos: [],
      etapas: [],
      medicoEtapa: undefined,
      openModal: false,
    };
  }

  render() {
    return (
      <ModalFaturamentoPage
        open={this.props.modalFaturamento}
        closeModal={this.closeModal.bind(this)}
        checkCloseModal={this.checkCloseModal.bind(this)}
        closeAlertaItemNaoFaturado={this.closeAlertaItemNaoFaturado.bind(this)}
        confirmar={this.confirmar.bind(this)}
        alertaPendentes={this.state.alertaPendentes}
        alertaTodoFaturado={this.state.alertaTodoFaturado}
        etapas={this.state.etapas}
        laudo={this.props.laudoSelecionado && this.props.laudoSelecionado.laudo}
        medicos={this.props.medicos}
        etapaSelecionada={this.state.etapaSelecionada}
        quantidadeASerFaturada={this.state.quantidadeASerFaturada}
        quantidadeASerFaturadaOnChange={this.quantidadeASerFaturadaOnChange.bind(
          this
        )}
        fatMedicoPadrao={this.props.fatMedicoPadrao}
        etapasOnChange={this.etapasOnChange.bind(this)}
        medicoOnChange={this.medicoOnChange.bind(this)}
        bloquearConfig={this.state.bloquearConfig}
        activeTab={this.state.activeTab}
        toggle={this.toggle.bind(this)}
        faturamentos={this.state.faturamentos}
        medicoEtapa={this.state.medicoEtapa}
        faturar={this.faturar.bind(this)}
      />
    );
  }

  checkCloseModal() {
    var pendente = this.state.faturamentos.filter(
      (fat) => fat.alterado || fat.novo
    );

    if (pendente.length > 0) {
      this.setState({
        alertaPendentes: true,
      });
    } else {
      this.closeModal(true);
    }
  }

  closeModal(closeFaturamento) {
    this.setState({
      alertaPendentes: false,
      alertaTodoFaturado: false,
    });

    if (closeFaturamento) {
      WebapiCommon.checkFaturamento(this.props.laudoSelecionado.laudo).then(
        (response) => {
          if (response) {
            this.props.commonActions.mudarStatusModalFaturamento(false);
          } else {
            this.setState({
              alertaTodoFaturado: true,
            });
          }
        }
      );
    }
  }

  closeAlertaItemNaoFaturado() {
    let usuarioLocalStorage = getUsuarioLocalStorage();
    WebapiCommon.gravarAuditoria(
      this.props.laudoSelecionado.laudo,
      `${usuarioLocalStorage.usuario} fechou o faturamento deixando itens não faturados`
    ).then((response) => {
      this.props.commonActions.mudarStatusModalFaturamento(false);
      this.closeModal(false);
    });
  }

  confirmar() {
    // Adicionar check para validar se as etapas foram faturadas
    this.props.actions.showFadeCarregando(true);
    var request = [];
    if (this.state.faturamentos.length > 0) {
      this.state.faturamentos.forEach((fat) => {
        if (fat.alterado || fat.novo) {
          request.push(
            WebapiCommon.faturar(this.props.laudoSelecionado.laudo, fat.etapa, {
              qtdFat: fat.qtdFaturado,
            })
          );
        }
        this.props.actions.showFadeCarregando(false);
        this.closeModal(true);
        this.props.commonActions.showAlerta(
          'sucesso',
          'Faturamento gravado com sucesso',
          2000
        );
      });

      Promise.all(request).then(() => {
        WebapiCommon.obterFaturamento(this.props.laudoSelecionado.laudo).then(
          (response) => {
            this.setState({
              faturamentos: response.data.map((fat) => {
                fat.alterado = false;
                fat.novo = false;
                return fat;
              }),
            });
            this.closeModal(true);
          }
        );
      });
    } else {
      this.props.actions.showFadeCarregando(false);
      this.closeModal(true);
    }
  }

  componentDidUpdate() {
    if (this.props.modalFaturamento && !this.state.openModal) {
      this.setState({ openModal: true });
      this.props.actions.showFadeCarregando(true);
      WebapiCommon.getConfiguracaoFaturamento().then((response) => {
        if (response.gerarFaturamentoMv && this.props.laudoSelecionado.laudo && this.props.laudoSelecionado.exame) {
          var requests = [
            WebapiCommon.obterFaturamento(this.props.laudoSelecionado.laudo),
            WebapiCommon.obterEtapasFaturaveis(
              this.props.laudoSelecionado.exame,
              this.props.laudoSelecionado.laudo
            ),
          ];
          var indice = 2;
          var index = {
            medico: undefined,
            medPadraoFat: undefined,
          };

          if (!this.props.medicos || this.props.medicos.length === 0) {
            requests.push(WebapiCommon.getMedicos());
            index.medico = indice;
            indice += 1;
          }
          if (this.props.fatMedicoPadrao === undefined) {
            requests.push(ConfiguracaoApi.getConfiguracaoRecebimentoMaterial());
            index.medPadraoFat = indice;
            indice += 1;
          }
          Promise.all(requests).then((response) => {
            this.setState({
              faturamentos: response[0] && response[0].data && response[0].data.map((fat) => {
                fat.alterado = false;
                fat.novo = false;
                return fat;
              }),
              etapas: response[1].data,
            });
            if (index.medico !== undefined) {
              this.props.commonActions.preencherMedicos(response[index.medico]);
            }

            if (index.medPadraoFat !== undefined) {
              this.props.commonActions.setMedicoPadraoFaturamento(
                response[index.medPadraoFat].faturarMedicoPadrao,
                response[index.medPadraoFat].medicoExecutantePadrao
              );
            }

            this.props.actions.showFadeCarregando(false);
          });
        } else {
          this.setState({
            bloquearConfig: true,
          });
          this.props.actions.showFadeCarregando(false);
        }
      });
    } else if (!this.props.modalFaturamento && this.state.openModal) {
      this.setState({ openModal: false });
    }
  }

  etapasOnChange(item) {
    if (this.props.fatMedicoPadrao || this.props.medPadraoFat) {
      this.setState({
        etapaSelecionada: item,
        medicoEtapa: this.props.medicos.find(
          (med) => med.value === this.props.medPadraoFat
        ),
      });
    } else {
      WebapiCommon.getMedicosEtapa(
        this.props.laudoSelecionado.laudo,
        item.value
      ).then((medico) => {
        this.setState({
          etapaSelecionada: item,
          medicoEtapa: medico,
        });
      });
    }
  }

  medicoOnChange(medico) {
    this.setState({
      medicoEtapa: medico,
    });
  }
  quantidadeASerFaturadaOnChange(value) {
    this.setState({
      quantidadeASerFaturada: value,
    });
  }

  toggle(tab) {
    this.setState({
      activeTab: tab,
    });
    if (tab === '2' && !this.props.listagemMultiplosExames || tab === '2' && this.props.listagemMultiplosExames && this.props.listagemMultiplosExames.length === 0) {
      WebapiCommon.getListagemMultiplosExames(
        this.props.laudoSelecionado.laudo
      ).then((listagem) => {
        this.props.actions.atualizarListagemMultiplosExames(listagem);
      });
    }
  }

  faturar(e) {
    this.props.actions.showFadeCarregando(true);

    if (this.state.quantidadeASerFaturada && this.state.etapaSelecionada) {
      if (!this.props.fatMedicoPadrao) {
        WebapiCommon.editarMedicoResponsavelLaudo(
          this.props.laudoSelecionado.laudo,
          this.state.medicoEtapa.value,
          this.state.etapaSelecionada.value,
          'medico'
        ).then((response) => {
          this.gravarFaturamento();
        });
      } else {
        this.gravarFaturamento();
      }
    } else {
      WebapiCommon.obterFaturamento(this.props.laudoSelecionado.laudo).then(
        (response) => {
          this.setState({ faturamentos: response.data });
          this.props.actions.showFadeCarregando(false);
        }
      );
    }
  }

  gravarFaturamento() {
    var oldFaturamento = this.state.faturamentos.find(
      (f) =>
        f.etapa.toUpperCase() ===
        this.state.etapaSelecionada.value.toUpperCase()
    );
    let faturamento;

    if (oldFaturamento) {
      oldFaturamento.qtdFaturado = this.state.quantidadeASerFaturada;

      if (!oldFaturamento.novo) {
        oldFaturamento.alterado = true;
      }

      faturamento = this.state.faturamentos.filter(
        (f) =>
          f.etapa.toUpperCase() !==
          this.state.etapaSelecionada.value.toUpperCase()
      );
      faturamento.push(oldFaturamento);
      this.setState({
        faturamentos: faturamento,
      });
      this.props.actions.showFadeCarregando(false);
    } else {
      faturamento = Object.assign(this.state.faturamentos);
      faturamento.push({
        alterado: false,
        etapa: this.state.etapaSelecionada.value,
        exameID: this.props.laudoSelecionado.exame,
        faturado: false,
        medico: this.state.medicoEtapa.label,
        medidoID: this.state.medicoEtapa.value,
        novo: true,
        qtdFaturado: this.state.quantidadeASerFaturada,
      });
      this.setState({
        faturamentos: faturamento,
      });
      this.props.commonActions.mudarStatusLaudoFaturado(true);
      this.props.commonActions.showFadeCarregando(false);
    }
  }
}

const mapStateToProps = (state) => {
  return {
    modalFaturamento: state.commonReducer.modalFaturamento,
    laudoSelecionado: state.recebimentoMaterial.laudoSelecionado,
    listagemMultiplosExames: state.recebimentoMaterial.listagemMultiplosExames,
    medicos: state.commonReducer.medicos,
    medPadraoFat: state.commonReducer.medPadraoFat,
    fatMedicoPadrao: state.commonReducer.fatMedicoPadrao,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalFaturamentoContainer);



// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/faturamento/modal.faturamento.container.js